import { render, staticRenderFns } from "./CompanyDetailSetting.vue?vue&type=template&id=541990d8"
import script from "./CompanyDetailSetting.vue?vue&type=script&lang=js"
export * from "./CompanyDetailSetting.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetailSetting.vue?vue&type=style&index=0&id=541990d8&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('541990d8')) {
      api.createRecord('541990d8', component.options)
    } else {
      api.reload('541990d8', component.options)
    }
    module.hot.accept("./CompanyDetailSetting.vue?vue&type=template&id=541990d8", function () {
      api.rerender('541990d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/CompanyDetailSetting.vue"
export default component.exports